// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__tgjPx","selects":"Documents_selects__Aytpw"};